<div *ngIf="content.errors.length">
  <nsc-card class="nsc-card--error">
    <nsc-card-title-error title="{{ content.errorTitle }}" icon="error"></nsc-card-title-error>
    <nsc-card-content>
      <div class="mat-typography">
        <p>
        {{content.errorBody}}
        </p>
      </div>
    </nsc-card-content>
  </nsc-card>

  <nsc-spacer size="sm"></nsc-spacer>
</div>
<form id="form" [formGroup]="formGroup">
  <nsc-card>
    <nsc-card-title note="All fields required, unless otherwise indicated">Payment Details</nsc-card-title>
    <nsc-card-content>
      <div class="row">
        <div class="col-12">
           
            <h3 class="mat-body-2 mat-hint payment-margin-bottom">Accepted Credit Cards:</h3>
           <br />
          <img class="cc-icon" src="/assets/credit-card-logo--visa.svg" alt="Visa">
          <img class="cc-icon" src="/assets/credit-card-logo--mastercard.svg" alt="Mastercard">
          <img class="cc-icon" src="/assets/credit-card-logo--amex.svg" alt="American Express">
          <img class="cc-icon" src="/assets/credit-card-logo--discover.svg" alt="Discover">

          <nsc-spacer size="sm"></nsc-spacer>
        </div>
        <div class="col-12 col-md-4">

          <label for="cc-name" class="control-label">Card Holder Name</label>
          <div class="form-controls payment-fields disabled" id="cc-name" data-cc-name></div>

        </div>

        <div class="col-12 col-md-4">

          <label for="cc-card" class="control-label">Card Number </label>
          <div class="form-controls payment-fields disabled empty" id="cc-card" data-cc-card></div>

        </div>

        <div class="col-12 col-md-4"></div>

        <div class="col-12 col-md-4">

          <label for="cc-exp" class="control-label">Exp Date</label>
          <div class="form-controls payment-fields disabled empty" id="cc-exp" data-cc-exp #expDate></div>

        </div>

        <div class="col-12 col-md-4">
          <label for="cc-cvv" class="control-label">CVV</label>
          <div class="form-controls payment-fields disabled empty" id="cc-cvv" data-cc-cvv></div>
        </div>
        <div class="col-12 col-md-4"></div>

        <div class="col-12 col-md-8">
          <nsc-form-field-toggle idx="use_contactinfo" controlName="useContactInfo"
            label="Do you want to use your contact address as your billing address?" [group]="formGroup">
          </nsc-form-field-toggle>
        </div>

        <div class="col-12 col-md-8">
          <nsc-form-field-input autocomplete="shipping address-line1" controlName="addressLine1"
            hint="Street number and name or PO Box" maxlength="30" placeholder="Address 1" [group]="formGroup">
          </nsc-form-field-input>
        </div>

        <div class="col-12 col-md-8">
          <nsc-form-field-input autocomplete="shipping address-line2" controlName="addressLine2"
            hint="Building, campus box, floor, apt, suite" maxlength="30" placeholder="Address 2" [group]="formGroup"
            [required]="false"></nsc-form-field-input>
        </div>
        <div class="col-12 col-md-4">
        </div>

        <div class="col-12 col-md-4">
          <nsc-form-field-input autocomplete="shipping address-level2" controlName="city" maxlength="30"
            placeholder="City" [group]="formGroup"></nsc-form-field-input>
        </div>
        <div class="col-12 col-md-4">
          <nsc-form-field-select-optgroup controlName="state" placeholder="{{ content.labelState }}" [group]="formGroup"
            [selectObjects]="values.states$.value"></nsc-form-field-select-optgroup>
        </div>

        <div class="col-12 col-md-4">
        </div>
        <div class="col-6 col-md-4">
          <nsc-form-field-input autocomplete="shipping postal-code" controlName="zip" hint="{{ content.hintZip }}"
            maxlength="15" placeholder="Zip/Postal Code" [group]="formGroup"></nsc-form-field-input>
        </div>
        <div class="col-6 col-md-4">
          <nsc-form-field-select controlName="country" placeholder="Country" [group]="formGroup"
            [selectObjects]="values.countries$.value"></nsc-form-field-select>
        </div>

        <div class="col-12">
          <div class="mat-caption">
            Selecting 'Submit Order' will transmit your payment information to
            <a href="https://www.firstdata.com/en_us/home.html" rel="noopener" target="_blank"
              aria-label="Open contact us in a new window">First Data Corp</a>,
            a third party payment processing provider. First Data will only share your name, address, or e-mail address
            with National Student Clearinghouse.
          </div>
        </div>
      </div>
    </nsc-card-content>
  </nsc-card>

  <nsc-spacer size="sm"></nsc-spacer>
  <div class="col-12 mat-typography" style="text-align: center;">
    <p class="mat-subheading-2">
      Total Fees for Order: {{ content.totalFees | currency }}
    </p>
  </div>

  <nsc-spacer size="sm"></nsc-spacer>



  <div class="nsc-form-actions">

    <button mat-raised-button id="orderpayment_cancel" class="nsc-form-actions__button" color="accent" type="button"
      (click)="cancel()">Cancel Order</button>
    <nsc-spacer horizontal="true" size="sm"></nsc-spacer>

    <button id="orderpayment_submitorder" color="primary" type="submit" mat-raised-button class="nsc-form-actions__button nsc-form-actions__button--next"
      data-submit-btn   >
      Submit Order <mat-icon aria-hidden="true" >chevron_right</mat-icon><span
        data-card-type></span>
    </button>
  </div>

</form>